import React from 'react';
import PropTypes from 'prop-types';

import { Show } from '../../../show';

import RadioGroup from '../../../radio-group';
import Spacer from '../../../spacer';
import Stack from '../../../stack';

import { ANSWER_LABELS, getCheckboxHighlight, getCheckboxCorrection } from '../../../../lib/checker';
import { CORRECT, MISSING, WRONG, INCOMPLETE } from '../../../../lib/exercise';
import { HIGHLIGHT_SUCCESS } from '../../../../constants/exercise';

const RESULT_LABELS = {
    [MISSING]: 'Risposta mancante.',
    [CORRECT]: 'Risposta esatta.',
    [WRONG]: 'Risposta sbagliata.',
    [INCOMPLETE]: 'Riposta sbagliata.',
};

const RadioFeedback = ({ exercise, answers, correctionStatus }) => {
    const { finalAnswer } = answers;

    const checkboxAnswerCorrection = getCheckboxCorrection(
        finalAnswer,
        exercise.answerType,
        correctionStatus?.state || correctionStatus?.status,
    );

    const highlight = getCheckboxHighlight(finalAnswer || exercise.answerType, correctionStatus, exercise.answerType, finalAnswer);

    return (
        <Stack gap="small">
            <strong>{'Risultato'}</strong>
            <RadioGroup
                exerciseId={exercise.id}
                options={[
                    {
                        id: finalAnswer,
                        highlight,
                        disabled: true,
                        checked: finalAnswer === exercise.answerType,
                        text: ANSWER_LABELS[finalAnswer || exercise.answerType],
                    },
                ]}
            />

            <strong>{RESULT_LABELS[checkboxAnswerCorrection]}</strong>

            <Show when={finalAnswer !== exercise.answerType && correctionStatus?.state !== MISSING}>
                <strong>{'La risposta esatta è:'}</strong>
                <Spacer size="small" />
                <RadioGroup
                    exerciseId={exercise.id}
                    options={[
                        {
                            id: finalAnswer,
                            highlight: HIGHLIGHT_SUCCESS,
                            disabled: true,
                            checked: false,
                            text: ANSWER_LABELS[exercise.answerType],
                        },
                    ]}
                />
            </Show>
        </Stack>
    );
};

RadioFeedback.propTypes = {
    answers: PropTypes.array,
    exercise: PropTypes.object,
    correctionStatus: PropTypes.object,
};

export default RadioFeedback;
